var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01416 3.9978C3.35726 3.9978 2.01416 5.3408 2.01416 6.9978V7.9978H22.0142V6.9978C22.0142 5.3408 20.6711 3.9978 19.0142 3.9978H5.01416ZM2.01416 9.9978V16.9978C2.01416 18.6548 3.35726 19.9978 5.01416 19.9978H19.0142C20.6711 19.9978 22.0142 18.6548 22.0142 16.9978V9.9978H2.01416ZM7.01416 11.9978H9.01416C9.56646 11.9978 10.0142 12.4458 10.0142 12.9978V14.9978C10.0142 15.5498 9.56646 15.9978 9.01416 15.9978H7.01416C6.46186 15.9978 6.01416 15.5498 6.01416 14.9978C6.01416 14.7478 6.01416 13.2478 6.01416 12.9978C6.01416 12.4458 6.46186 11.9978 7.01416 11.9978Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.c4aeac1f.svg";
export { ForwardRef as ReactComponent };